import { Card, Typography, Avatar, Chip, alpha } from "@mui/material";
import { IDelegate } from "../../../interfaces/IDelegate";

export default function ParticipantCard({
    participant,
    role,
    onClick,
    primaryColor = '#493193',
    secondaryColor = '#2fadd8',
}: {
    participant: IDelegate;
    role?: string;
    onClick?: (p: IDelegate) => void;
    primaryColor?: string;
    secondaryColor?: string;
    }) {
    //console.log("role--->>>>",role)
    return (
        <Card
            elevation={1}
            sx={{
                borderRadius: 3,
                background: `linear-gradient(120deg, ${alpha(primaryColor, 0.02)} 60%, ${alpha(secondaryColor, 0.03)} 100%)`,
                border: `1px solid ${alpha(primaryColor, 0.1)}`,
                boxShadow: `0 4px 24px ${alpha(primaryColor, 0.08)}`,
                backdropFilter: "blur(8px)",
                cursor: "pointer",
                transition: 'all 0.3s ease',
                "&:hover, &:focus": {
                    transform: "translateY(-4px)",
                    boxShadow: `0 12px 40px ${alpha(primaryColor, 0.15)}`,
                    borderColor: alpha(primaryColor, 0.3),
                },
                p: 2,
                mb: 3,
                minWidth: 0,
                maxWidth: 380,
                width:"100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
            }}
            onClick={() => onClick?.(participant)}
            tabIndex={0}
            aria-label={`View details for ${participant.firstname} ${participant.lastname}`}
        >
            <Avatar
                src={participant.imageUrl}
                alt={`${participant.firstname} ${participant.lastname}`}
                title={`${participant.firstname} ${participant.lastname}`}
                sx={{
                    width: 96,
                    height: 96,
                    mb: 2.5,
                    boxShadow: `0 4px 12px ${alpha(primaryColor, 0.15)}`,
                    border: `4px solid ${alpha(primaryColor, 0.15)}`,
                }}
            />
            <Typography
                variant="h5"
                sx={{
                    fontWeight: 700,
                    textAlign: "center",
                    color: "text.primary",
                    mb: 1,
                    letterSpacing: 0.1,
                }}
            >
                {participant.firstname} {participant.lastname}
            </Typography>
            {role && (
                <Chip
                    label={role}
                    size="medium"
                    sx={{
                        mb: 2,
                        fontWeight: 600,
                        letterSpacing: 0.2,
                        px: 2,
                        py: 1,
                        fontSize: "1rem",
                        borderRadius: '50px',
                        background: `linear-gradient(90deg, ${primaryColor} 60%, ${secondaryColor} 100%)`,
                        color: "#fff",
                        boxShadow: `0 4px 14px ${alpha(primaryColor, 0.4)}`,
                    }}
                    aria-label={`Role: ${role}`}
                />
            )}
            {/*<Stack spacing={0.5} sx={{ width: "100%", alignItems: "center", mt: 1 }}>*/}
            {/*    {participant.jobTitle && (*/}
            {/*        <Typography*/}
            {/*            variant="body1"*/}
            {/*            color="text.secondary"*/}
            {/*            sx={{*/}
            {/*                textAlign: "center",*/}
            {/*                fontWeight: 500,*/}
            {/*                letterSpacing: 0.1,*/}
            {/*            }}*/}
            {/*        >*/}
            {/*            {participant.jobTitle}*/}
            {/*        </Typography>*/}
            {/*    )}*/}
            {/*    {participant.company && (*/}
            {/*        <Typography*/}
            {/*            variant="body2"*/}
            {/*            color="text.secondary"*/}
            {/*            sx={{*/}
            {/*                textAlign: "center",*/}
            {/*                fontWeight: 400,*/}
            {/*                letterSpacing: 0.1,*/}
            {/*            }}*/}
            {/*        >*/}
            {/*            {participant.company}*/}
            {/*        </Typography>*/}
            {/*    )}*/}
            {/*</Stack>*/}
        </Card>
    );
}